export enum CommonApiRoutes {
	Search = 'search',
	Export = 'export',
	Import = 'import',
	Options = 'options',
	RecentOptions = 'recent-options',
	Exist = 'exist',
	Excluded = 'excluded',
	Execute = 'execute',
	File = 'file',
	Resolve = 'resolve',
	ResolveAll = 'resolve-all',
	BatchUpdate = 'batch',
	BulkUpdate = 'bulk',
	CheckDuplicates = 'duplicates/check',
	CheckDuplicatesByName = 'duplicates/check-by-name',
	CheckOverlap = 'duplicates/check-overlap',
	CheckBulkOperationDisabled = 'bulk/disabled',
	History = 'history',
	TotalCount = 'total-count',
	GenerateFile = 'generate',
	DownloadFile = 'download',
	Delete = 'delete',
	Upload = 'upload'
}

export enum UserApiRoutes {
	Root = 'users',
	CheckDuplicates = 'duplicates/check-by-email'
}

export enum RoleApiRoutes {
	Root = 'roles',
	Permissions = 'permissions'
}

export enum NdcApiRoutes {
	Root = 'ndc',
	Lookup = 'lookup',
	NdcDrugName = 'ndc-drug-name',
	IsNdcMedispanExists = 'is-ndc-medispan-exist',
	NdcDrugList = 'ndc-drug-list'
}

export enum NdcListApiRoutes {
	Root = 'ndc/list',
	ImportFile = 'import',
	ConnectedInstances = 'connected-instances'
}

export enum DrugClassApiRoutes {
	Root = 'drug-class',
	DrugClassLookup = 'lookup'
}

export enum DrugClassListApiRoutes {
	Root = 'drug-class/list'
}

export enum CustomerApiRoutes {
	Root = 'customer',
	CheckDuplicatesByHierarchy1 = 'duplicates/check-by-hierarchy1',
	CheckDuplicatesByHierarchy2 = 'duplicates/check-by-hierarchy2',
	CheckCreatedLocationSubtypes = 'check-created-location-subtypes',
	CheckCreatedLocationTypes = 'check-created-location-types',
	ImportLocations = 'import-locations',
	DownstreamClientIdOptions = 'downstream-client-id/options',
	FileMappingConfig = 'file-mapping-config',
	LocationsFile = 'locations',
	SystemId = 'system/id',
	AscellaHierarchyIdentifier = 'ascella-hierarchy-identifier',
	CheckDuplicatesByAscellaId = 'duplicates/check-by-ascellaid',
	ExpectedCustomersCount = 'expected-customers-count'
}

export enum GeneratedFileApiRoutes {
	Root = 'generated-file'
}

export enum CustomerContractPaymentApiRoutes {
	Root = 'customer/contract-payment'
}

export enum CustomerHistoryApiRoutes {
	Root = 'customer/history'
}

export enum CustomerRetentionRateApiRoutes {
	Root = 'customer/retention-rate'
}

export enum CustomerTechEnablementFeeApiRoutes {
	Root = 'customer/tech-enablement-fee'
}

export enum CustomerFeeApiRoutes {
	Root = 'customer/fee'
}

export enum CustomerNoteApiRoutes {
	Root = 'customer/note',
	Restore = 'restore',
	Recent = 'recent'
}

export enum CustomerRebateGroupApiRoutes {
	Root = 'customer/rebate-group'
}

export enum CustomerRebateAggregatorAttributeValueApiRoutes {
	Root = 'customer/rebate-aggregator-attribute-value'
}

export enum CustomerMonthlyDataApiRoutes {
	Root = 'statistics',
	Customer = 'customer',
	Location = 'location',
	ScriptCount = 'script-count',
	Monthly = 'monthly',
	TotalWacPrices = 'total-wac',
	Transaction = 'transaction',
	Drugs = 'drugs',
	Submission = 'submission',
	FillDates = 'fill-dates',
	MarkAsReady = 'ready',
	Recalculate = 'recalculate',

	CurrentPeriod = 'current-period',
	RecentPeriods = 'recent-periods',

	FilterLevels = 'filter-levels'
}

export enum FacilityApiRoutes {
	Root = 'facility',
	Tags = 'tags',
	Map = 'map',
	All = 'all',
	CheckDuplicatesByHierarchyLevel3 = 'duplicates/check-by-hierarchy3',
	CheckMappingDuplicates = 'duplicates/check-mapping',
	EnableLocations = 'enable',
	Generate = 'generate'
}

export enum NcpdpApiRoutes {
	Root = 'ncpdp',
	Location = 'location',
	CheckIsNcpdpOpenDateBeforeLocationEarliestDate = 'check-ncpdp-opendate-earliestdate'
}

export enum Status340BApiRoutes {
	Root = 'status340b',
	Location = 'location',
	historyExists = 'history-exists'
}

export enum NpiApiRoutes {
	Root = 'npi',
	DataQ = 'dataq'
}

export enum PayableApiRoutes {
	Root = 'payable',
	Approve = 'approve',
	PutUnderDevelopment = 'put-under-development'
}

export enum ProfileRoutes {
	Root = 'profile',
	Info = 'info'
}

export enum AuthRoutes {
	Root = 'auth',
	Challenge = 'challenge',
	Token = 'token',
	RefreshToken = 'refresh-token'
}

export enum PasswordRoutes {
	Root = 'password',
	SendForgotPasswordEmail = 'send-forgot-password-email',
	ConfirmAuthenticatedUserPasswordReset = 'confirm-authenticated-user-password-reset',
	ConfirmPasswordReset = 'confirm-password-reset',
	PasswordChangeRequest = 'password-change-request',
	CurrentUserPasswordChangeRequest = 'current-user-password-change-request'
}

export enum RebateReceivableApiRoutes {
	Root = 'rebate-receivable',
	Lock = 'lock',
	PutUnderDevelopment = 'put-under-development',
	GroupedSearch = 'grouped-search'
}

export enum ProcessingConfigApiRoutes {
	Root = 'processing-config',
	Mapping = 'mapping',
	Validation = 'validation',
	Duplicate = 'duplicate',
	Aggregation = 'aggregation',
	Conversion = 'conversion',
	Processing = 'processing'
}

export enum RebateAggregatorApiRoutes {
	Root = 'rebate-aggregator',
	Rate = 'ndc-rates',
	CheckNdcFormularyDuplicates = 'duplicates/check-ndc-formulary',
	CheckNdcFormularyEffectiveDateOverlaping = 'check-ndc-formulary-effective-date-overlapping',
	AddRate = 'add-rate',
	SearchRebateAggregatorNdcLists = 'search-rebate-aggregator-ndc-lists',
	CheckDuplicates = 'duplicates/check-by-effective-date',
	Formulary = 'formulary',
	Aggregator = 'aggregator',
	Ndc = 'ndc',
	Attribute = 'attribute',
	MappingValidation = 'mapping-validation'
}

export enum SubmissionFileApiRoutes {
	Root = 'submission-file',
	Versions = 'versions',
	GenerateDebug = 'generate/debug',
	GenerateProduction = 'generate/production',
	DownloadDebugFile = 'file/debug',
	DownloadProductionFile = 'file/production',
	DownloadEncryptedFile = 'file/encrypted',
	SubmitProductionFile = 'submit/production',
	FinalizeProductionFile = 'finalize/production',
	AggregatorOptions = 'aggregator/options',
	SubmittedData = 'submitted-data',
	SubmittedDataSearch = 'submitted-data/search'
}

export enum ReportApiRoutes {
	Root = 'report',
	DownloadFile = 'file',
	Generate = 'generate',
	RejectedRecordsSummary = 'rejected-records/summary',
	RejectedRecordsSearch = 'rejected-records/search'
}

export enum PayorsApiRoutes {
	Root = 'payor',
	Customer = 'customer',
	Review = 'review',
	ReviewFiltered = 'review-filtered'
}

export enum SubmissionPeriodApiRoutes {
	Root = 'submission-period',
	Active = 'active',
	Recent = 'recent',
	Status = 'status',
	CheckByDates = 'check-by-dates'
}

export enum LineOfBusinessApiRoutes {
	Root = 'lob'
}

export enum LineOfBusinessSubtypeApiRoutes {
	Root = 'lob/subtype'
}

export enum BdcApiRoutes {
	Root = 'bdc'
}

export enum CustomerBdcApiRoutes {
	Root = 'customer/bdc'
}

export enum CustomerCustomDateOfServiceApiRoutes {
	Root = 'customer/custom-dos',
	CheckDuplicates = 'duplicates/check-by-id'
}

export enum NdcReplacementMappingApiRoutes {
	Root = 'ndc/replacement',
	CheckByDates = 'check-by-dates'
}

export enum DownstreamClientIdAssociationApiRoutes {
	Root = 'downstream-client-id-association',
	CheckByDates = 'check-by-dates'
}

export enum AberrantQuantityApiRoutes {
	Root = 'aberrant-quantity',
	CheckDuplicates = 'duplicates/check-by-ndc'
}

export enum UnbreakableQuantityApiRoutes {
	Root = 'unbreakable-quantity',
	CheckDuplicates = 'duplicates/check-by-ndc',
	Medispan = 'medispan'
}

export enum RebateGroupApiRoutes {
	Root = 'rebate-group',
	CheckDuplicates = 'duplicates/check-by-submission-periods'
}

export enum RebateGroupRebateAggregatorAttributeValueApiRoutes {
	Root = 'rebate-group/rebate-aggregator-attribute-value'
}

export enum ExcludedPharmacyApiRoutes {
	Root = 'excluded-pharmacy',
	Options = 'options',
	CheckDuplicates = 'duplicates/check-by-ncpdp',
	DataQ = 'dataq'
}

export enum InOutpatientDefinitionApiRoutes {
	Root = 'in-outpatient-definition',
	CustomerDefinitions = 'customer-definitions'
}

export enum NonPatientExclusionApiRoutes {
	Root = 'non-patient-exclusion',
	CheckDuplicates = 'duplicates/check-by-value'
}

export enum AuditEventsApiRoutes {
	Root = 'audit',
	RebateLoad = 'rebate-load',
	AdminRecords = 'admin-records',
	Users = 'users',
	Roles = 'roles'
}

export enum RebateGroupAggregatorNdcApiRoutes {
	Root = 'rebate-group-aggregator-ndc',
	CheckByDates = 'check-by-dates',
	Customer = 'customer',
	Files = 'files',
	ImportNdc = 'import-ndc',
	ValidationErrors = 'validation-errors',
	DateOverlaps = 'date-overlaps',
	AutoResolveDateOverlap = 'auto-fix',
	UpdateSystemRecord = 'update-system-record',
	UpdateImportedOverlapRecord = 'update-imported-record',
	DeleteImportedOverlapRecord = 'delete-imported-record',
	BulkAutoFix = 'bulk-auto-fix',
	Rollback = 'rollback',
	BulkRollback = 'bulk-rollback',
	BulkRollbackByFilter = 'bulk-rollback-by-filter',
	Records = 'records',
	Details = 'details'
}

export enum SubmissionTaskApiRoutes {
	Root = 'submission-task'
}

export enum SubmissionCommentApiRoutes {
	Root = 'submission-task/comment',
	Attachment = 'attachment'
}

export enum UserNotificationApiRoutes {
	Root = 'user/notifications',
	UnreadCount = 'unread-count',
	MarkRead = 'mark-read',
	MarkAllRead = 'mark-all-read',
	DeleteAllRead = 'delete-all-read'
}
